export { AutomationsManagement } from './root.page'
